import styled from "styled-components";
import {Button, Paper} from "@material-ui/core";

export const ContentMainStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 16px;
`;


export const FormContentMainStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const FormContentSizeMainStyled = styled.div`
    width: 40%;
`;

export const FormContentSizeTableMainStyled = styled.div`
    width: 70%;
`;

export const FilterContentStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: row;
`;

export const FooterContentStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
`;

export const FormContentSizeButtonMainStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    button {
        width: 40%;
    }
`;


/// Modal

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  font-family: Arial, sans-serif;
`;

export const MetricsRowStyled = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const MetricCardStyled = styled.div`
  flex: 1;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const MetricValueStyled = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #1e5f8a;
  line-height: 1.2;
`;

export const MetricLabelStyled = styled.span`
  font-size: 13px;
  color: #666666;
  margin-top: 4px;
  text-align: center;
`;

export const PreviewContainerStyled = styled.div`
  background-color: #e9ecef;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PreviewHeaderStyled = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #6c757d;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const NotificationCardStyled = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
`;

export const AvatarStyled = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #1e5f8a;
  color: #ffffff;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const NotificationContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const NotificationTitleRowStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
`;

export const NotificationTitleStyled = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: #000000;
`;

export const NotificationTimeStyled = styled.span`
  font-size: 12px;
  color: #888888;
`;

export const NotificationBodyStyled = styled.span`
  font-size: 13px;
  color: #444444;
  word-break: break-word;
`;

export const ActionsRowStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

export const BackButtonStyled = styled.button`
  background: transparent;
  border: none;
  color: #1e5f8a;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 4px;
  text-transform: uppercase;

  &:hover {
    background-color: rgba(30, 95, 138, 0.05);
  }
`;

export const ConfirmButtonStyled = styled.button`
  background-color: #1e5f8a;
  border: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 4px;
  text-transform: uppercase;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;

  &:hover {
    background-color: #174b6e;
  }
`;

export const PushStatusBadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.active ? '#E8F5E9' : '#FFF3E0'};
  color: ${props => props.active ? '#388E3C' : '#E65100'};
`;




